import { TAnyCodec, TCodec, TTypeOfCodec, TTypeOfNewDefault } from "../codec";
import { either } from "fp-ts/lib";
import { TError, errorConstants } from "../errors";
import { decodeArray, decode } from "./array";
import { NonEmptyArray } from "fp-ts/lib/NonEmptyArray";

export type TAnyNonEmptyArrayCodec = TCodec<
    "NonEmptyArrayCodec",
    { codec: TAnyCodec },
    NonEmptyArray<unknown>,
    Array<unknown>
>;

export type TNonEmptyArrayCodec<A extends TAnyCodec> = TCodec<"NonEmptyArrayCodec", { codec: A }, NonEmptyArray<TTypeOfCodec<A>>, NonEmptyArray<TTypeOfCodec<A>>>;

export const nonEmptyArray = <
    A extends TAnyCodec,
    D extends NonEmptyArray<TTypeOfCodec<A>>,
    N extends Array<TTypeOfNewDefault<A>>
>(payload: A): TCodec<"NonEmptyArrayCodec", { codec: A }, D, N> => ({
    type: "NonEmptyArrayCodec",
    payload: { codec: payload },
    decode: (input: unknown): either.Either<TError, D> => {
        if (! Array.isArray(input)) {
            return either.left([[errorConstants.ARRAY_VALIDATION, ""]]);
        }

        if (input.length === 0) {
            return either.left([[errorConstants.NON_EMPTY_ARRAY_VALIDATION, ""]]);
        }

        return decodeArray(input, payload, "decode");
    },
    decodeNewDefault: decode(payload, "decodeNewDefault"),
    newDefault: () => [] as unknown as N,
});
